export enum CurrencyEnum {
    US_DOLLAR = 1,
    CANADIAN_DOLLAR = 2,
    POUND_STERLING = 3,
    EURO = 4,
    AUSTRALIAN_DOLLAR = 5,
}
